"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WABA360DialogCommonEnumsWhatsAppLanguage = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var WABA360DialogCommonEnumsWhatsAppLanguage;
(function (WABA360DialogCommonEnumsWhatsAppLanguage) {
    WABA360DialogCommonEnumsWhatsAppLanguage["Af"] = "af";
    WABA360DialogCommonEnumsWhatsAppLanguage["Sq"] = "sq";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ar"] = "ar";
    WABA360DialogCommonEnumsWhatsAppLanguage["Az"] = "az";
    WABA360DialogCommonEnumsWhatsAppLanguage["Bn"] = "bn";
    WABA360DialogCommonEnumsWhatsAppLanguage["Bg"] = "bg";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ca"] = "ca";
    WABA360DialogCommonEnumsWhatsAppLanguage["ZhCn"] = "zh_CN";
    WABA360DialogCommonEnumsWhatsAppLanguage["ZhHk"] = "zh_HK";
    WABA360DialogCommonEnumsWhatsAppLanguage["ZhTw"] = "zh_TW";
    WABA360DialogCommonEnumsWhatsAppLanguage["Hr"] = "hr";
    WABA360DialogCommonEnumsWhatsAppLanguage["Cs"] = "cs";
    WABA360DialogCommonEnumsWhatsAppLanguage["Da"] = "da";
    WABA360DialogCommonEnumsWhatsAppLanguage["Nl"] = "nl";
    WABA360DialogCommonEnumsWhatsAppLanguage["En"] = "en";
    WABA360DialogCommonEnumsWhatsAppLanguage["EnGb"] = "en_GB";
    WABA360DialogCommonEnumsWhatsAppLanguage["EnUs"] = "en_US";
    WABA360DialogCommonEnumsWhatsAppLanguage["Et"] = "et";
    WABA360DialogCommonEnumsWhatsAppLanguage["Fil"] = "fil";
    WABA360DialogCommonEnumsWhatsAppLanguage["Fi"] = "fi";
    WABA360DialogCommonEnumsWhatsAppLanguage["Fr"] = "fr";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ka"] = "ka";
    WABA360DialogCommonEnumsWhatsAppLanguage["De"] = "de";
    WABA360DialogCommonEnumsWhatsAppLanguage["El"] = "el";
    WABA360DialogCommonEnumsWhatsAppLanguage["Gu"] = "gu";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ha"] = "ha";
    WABA360DialogCommonEnumsWhatsAppLanguage["He"] = "he";
    WABA360DialogCommonEnumsWhatsAppLanguage["Hi"] = "hi";
    WABA360DialogCommonEnumsWhatsAppLanguage["Hu"] = "hu";
    WABA360DialogCommonEnumsWhatsAppLanguage["Id"] = "id";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ga"] = "ga";
    WABA360DialogCommonEnumsWhatsAppLanguage["It"] = "it";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ja"] = "ja";
    WABA360DialogCommonEnumsWhatsAppLanguage["Kn"] = "kn";
    WABA360DialogCommonEnumsWhatsAppLanguage["Kk"] = "kk";
    WABA360DialogCommonEnumsWhatsAppLanguage["RwRw"] = "rw_RW";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ko"] = "ko";
    WABA360DialogCommonEnumsWhatsAppLanguage["KyKg"] = "ky_KG";
    WABA360DialogCommonEnumsWhatsAppLanguage["Lo"] = "lo";
    WABA360DialogCommonEnumsWhatsAppLanguage["Lv"] = "lv";
    WABA360DialogCommonEnumsWhatsAppLanguage["Lt"] = "lt";
    WABA360DialogCommonEnumsWhatsAppLanguage["Mk"] = "mk";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ms"] = "ms";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ml"] = "ml";
    WABA360DialogCommonEnumsWhatsAppLanguage["Mr"] = "mr";
    WABA360DialogCommonEnumsWhatsAppLanguage["Nb"] = "nb";
    WABA360DialogCommonEnumsWhatsAppLanguage["Fa"] = "fa";
    WABA360DialogCommonEnumsWhatsAppLanguage["Pl"] = "pl";
    WABA360DialogCommonEnumsWhatsAppLanguage["PtBr"] = "pt_BR";
    WABA360DialogCommonEnumsWhatsAppLanguage["PtPt"] = "pt_PT";
    WABA360DialogCommonEnumsWhatsAppLanguage["Pa"] = "pa";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ro"] = "ro";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ru"] = "ru";
    WABA360DialogCommonEnumsWhatsAppLanguage["Sr"] = "sr";
    WABA360DialogCommonEnumsWhatsAppLanguage["Sk"] = "sk";
    WABA360DialogCommonEnumsWhatsAppLanguage["Sl"] = "sl";
    WABA360DialogCommonEnumsWhatsAppLanguage["Es"] = "es";
    WABA360DialogCommonEnumsWhatsAppLanguage["EsAr"] = "es_AR";
    WABA360DialogCommonEnumsWhatsAppLanguage["EsEs"] = "es_ES";
    WABA360DialogCommonEnumsWhatsAppLanguage["EsMx"] = "es_MX";
    WABA360DialogCommonEnumsWhatsAppLanguage["Sw"] = "sw";
    WABA360DialogCommonEnumsWhatsAppLanguage["Sv"] = "sv";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ta"] = "ta";
    WABA360DialogCommonEnumsWhatsAppLanguage["Te"] = "te";
    WABA360DialogCommonEnumsWhatsAppLanguage["Th"] = "th";
    WABA360DialogCommonEnumsWhatsAppLanguage["Tr"] = "tr";
    WABA360DialogCommonEnumsWhatsAppLanguage["Uk"] = "uk";
    WABA360DialogCommonEnumsWhatsAppLanguage["Ur"] = "ur";
    WABA360DialogCommonEnumsWhatsAppLanguage["Uz"] = "uz";
    WABA360DialogCommonEnumsWhatsAppLanguage["Vi"] = "vi";
    WABA360DialogCommonEnumsWhatsAppLanguage["Zu"] = "zu";
})(WABA360DialogCommonEnumsWhatsAppLanguage = exports.WABA360DialogCommonEnumsWhatsAppLanguage || (exports.WABA360DialogCommonEnumsWhatsAppLanguage = {}));
